<template>
  <div class="table-container">
    <el-table
      height="1000"
      max-height="1000"
      :data="tableStore.sortedTableData"
      :scrollbar-always-on="true"
      stripe
      border
      :responsive="false"
    >
      <InvoiceNumberColumn />
      <EmailColumn />
      <PinColumn />
      <EmailHashColumn />
      <DueColumn />
      <TrackingColumn />
      <ViewsColumn />
      <InvoiceStatusColumn />
      <ReviewColumn :on-pin-grab="onPinGrab" />
      <CreatedAtColumn />
      <ActionsColumn />
    </el-table>
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { useReviewers, useTable } from "@/stores";
import InvoiceNumberColumn from "./ReviewersTable/InvoiceNumberColumn.vue";
import EmailColumn from "./ReviewersTable/EmailColumn.vue";
import PinColumn from "./ReviewersTable/PinColumn.vue";
import EmailHashColumn from "./ReviewersTable/EmailHashColumn.vue";
import DueColumn from "./ReviewersTable/DueColumn.vue";
import TrackingColumn from "./ReviewersTable/TrackingColumn.vue";
import ViewsColumn from "./ReviewersTable/ViewsColumn.vue";
import InvoiceStatusColumn from "./ReviewersTable/InvoiceStatusColumn.vue";
import ReviewColumn from "./ReviewersTable/ReviewColumn.vue";
import CreatedAtColumn from "./ReviewersTable/CreatedAtColumn.vue";
import ActionsColumn from "./ReviewersTable/ActionsColumn.vue";

const tableStore = useTable();
const reviewersStore = useReviewers();

const props = defineProps({
  pinSearch: {
    type: String,
    default: "",
  },
  onPinGrab: {
    type: Function,
    required: true,
  },
});

const filterTableData = computed(() => {
  if (!reviewersStore.reviewers || reviewersStore.reviewers.length === 0) {
    return [];
  }

  const filteredData = reviewersStore.reviewers.filter(
    (data) =>
      !props.pinSearch ||
      (data.pin !== undefined &&
        data.pin !== null &&
        data.pin.toString().includes(props.pinSearch))
  );

  return filteredData;
});

watch(
  filterTableData,
  (newValue) => {
    if (newValue.length > 0) {
      tableStore.setTableData([...newValue]);
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.table-container {
  overflow-x: auto;
}
</style>
